class MHeader extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            headers: ["header"],
            logos: [".m-logo"],
            topbar: ".m-topbar",
            headerWrapper: ".m-header__wrapper",
            topbarClose: ".m-topbar__close"
        };
        this.domNodes = queryDomNodes(this.selectors, this);
        this.innerWidth = window.innerWidth;
        this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
        this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
        this.stickyEnabled = "true" === this.dataset.sticky || false;
        this.classes = {
            stuck: "stuck"
        };
        this.init();
    }

    init() {
        this.transparentHeader = this.domNodes && this.domNodes.headers[0] && "true" === this.domNodes.headers[0].dataset.transparent;
        this.initAddon();
        this.handleSticky();
        document.addEventListener("matchMobile", () => this.handleSticky());
        document.addEventListener("unmatchMobile", () => this.handleSticky());
        this.siteNav = new SiteNav(this);
        window.__sfHeader = this;
        window.addEventListener("resize", () => {
            this.innerWidth = window.innerWidth;
        });
        if (this.transparentHeader && this.innerWidth > 1280) {
            this.domNodes.headerWrapper.classList.add("transparent-on-top");
        } else {
            this.domNodes.headerWrapper.classList.remove("transparent-on-top");
        }
    }

    initAddon() {
        this.megamenu = new Megamenu(this);
        if (Shopify.designMode) {
            MinimogTheme = MinimogTheme || {};
            if (MinimogTheme && MinimogTheme.Wishlist) {
                MinimogTheme.Wishlist.updateWishlistCount();
            }
        }
    }

    handleSticky() {
        let offset = 20;
        document.querySelectorAll(".shopify-section-group-header-group").forEach((element) => {
            if (!element.classList.contains("m-section-header")) {
                offset += element.offsetHeight;
            }
        });

        const topBar = document.querySelector(".m-topbar");
        if (topBar) {
            offset += topBar.offsetHeight;
        }

        if (!this.stickyEnabled) return;

        window.addEventListener("scroll", () => {
            const currentScroll = window.scrollY;

            if (currentScroll <= offset) {
                this.classList.remove(this.classes.stuck);
                if (this.transparentHeader && this.innerWidth > 1279) {
                    this.domNodes.headerWrapper.classList.add("transparent-on-top");
                }
            } else {
                this.classList.add(this.classes.stuck);
                if (this.transparentHeader && this.innerWidth > 1279) {
                    this.domNodes.headerWrapper.classList.remove("transparent-on-top");
                }
            }
        });
    }
}

customElements.define("m-header", MHeader);
